import playerSlice from './player/player_slice';

const rootReducer = {
  playerSlice,
};

export default rootReducer;
